import { LitElement, css, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { consume } from '@lit/context';
import { sortContext } from '../contexts/sort';
import { SORT } from '../util/filter-sort';
import { makeCustomEvent, EVENT } from '../util/events';

@customElement('rq-sort-select')
export class SortSelect extends LitElement {
    static styles = css`
        .wrapper {
            width: 100%;
        }
    `;
    @consume({ context: sortContext })
    sort!: SORT;

    connectedCallback(): void {
        super.connectedCallback();
        this.addEventListener('lh-change', this.listenerHandler as EventListener);
        this.addEventListener('lh-input', this.listenerHandler as EventListener);
    }

    private listenerHandler({ detail: { value } }: CustomEvent<{ value: SORT }>) {
        this.dispatchEvent(makeCustomEvent(EVENT.SET_FILTER_SORT, { sort: value }));
    }

    render() {
        return html`<div class="wrapper">
            <lh-select name="sort" value=${this.sort}>
                ${Object.values(SORT).map(
                    (sort) => html`<lh-option slot="options" value=${sort}>Sort By: ${sort}</lh-option>`
                )}
            </lh-select>
        </div>`;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'rq-sort-select': SortSelect;
    }
}
